export default function choiceSelectionsFromBase(
  choiceSets: ChoiceSet[],
  keyProperty: 'key' | 'id' = 'key',
  stockBalanceDataMap?: SDict<StockBalanceData>,
): ChoiceSelections {
  const result: ChoiceSelections = {};

  const preSelect = (c: Choice): string[] => {
    const baseQty = c.baseQuantity || 0;

    if (stockBalanceDataMap && c.plucode in stockBalanceDataMap) {
      const adjustedBalance =
        stockBalanceDataMap[c.plucode].cartAdjustedBalance || 0;

      if (adjustedBalance >= c.baseQuantity) {
        return Array(baseQty).fill(c.id);
      } else {
        return [];
      }
    }

    return Array(baseQty).fill(c.id);
  };

  choiceSets.forEach(choiceSet => {
    let selections: string[] = [];
    choiceSet.choices.forEach(choice => {
      selections = [...selections, ...preSelect(choice)];
    });

    result[choiceSet[keyProperty]] = selections;
  });

  return result;
}
